import { useSelector } from 'react-redux';
import { Box } from '@chakra-ui/react';
import { ApplicationState } from '../../../../../store';
import { PrevNextButtons } from '../../../../PrevNextButtons';
import { FileList } from '../../../../FileList/FileList';

import { useNavigate } from 'react-router-dom';
import ApplicantHeader from '../../../../../components/molecules/applicantHeader';
import { SectionHeader, SectionTitles } from '@/components/molecules/SectionHeader';
import { getApplicationData } from '../helpers';
import { useTaskRouteGuard } from '@/hooks/useTaskRouteGuard';
import { TaskLoadingSkeleton } from '@/components/molecules/TaskLoadingSkeleton';
import { useTaskNavigation } from '@/hooks/useTaskNavigation';

export default function PersonalStatement() {
  const { allDocuments } = useSelector((state: ApplicationState) => state.apply);
  const navigate = useNavigate();
  const { nextRoute, previousRoute } = useTaskNavigation();

  // Route guard - redirects if task is disabled
  const { isLoading } = useTaskRouteGuard('/personal-statement');

  const { application } = useSelector((state: ApplicationState) => state.apply);

  if (isLoading) {
    return <TaskLoadingSkeleton />;
  }

  const { initial, current } = getApplicationData(application);

  const { hasPersonalStatementDocument } = current;
  const initialHasPersonalStatementDocument = initial.hasPersonalStatementDocument;

  const hasNoPersonalStatement =
    hasPersonalStatementDocument === false && initialHasPersonalStatementDocument === false;

  const hasNoDocument = allDocuments?.personalStatement === undefined || allDocuments?.personalStatement.length === 0;

  const showNoPersonalStatementAlert = hasNoPersonalStatement && hasNoDocument;

  return (
    <>
      <ApplicantHeader pageName="Application" />
      <Box>
        <SectionHeader title={SectionTitles.PERSONAL_STATEMENT} />

        <FileList files={allDocuments?.personalStatement || []} />

        <Box>
          {showNoPersonalStatementAlert && (
            <Box bgColor="utility.100" px={5} py={3} color="muted">
              The applicant has no data for this task
            </Box>
          )}
        </Box>

        <Box mt={6}>
          <PrevNextButtons
            onPrevious={previousRoute ? () => navigate(previousRoute) : undefined}
            onNext={nextRoute ? () => navigate(nextRoute) : undefined}
          />
        </Box>
      </Box>
    </>
  );
}
